//
import Vue from "vue"
import Router from "vue-router"

//
import Guard from "./Guard"
import DashboardRoutes from "./Dashboard"
import AuthRoutes from "./Auth"

//
Vue.use(Router)

//
const router = new Router({
    mode: "hash",
    base: process.env.BASE_URL,
    routes: [
        ...DashboardRoutes,
        ...AuthRoutes,
    ],
})

//
router.beforeEach(Guard)

//
export default router